
function capitalize(input: string) {
  if (!input) {
    return input;
  }
  // this capitalizes each word of a string
  return input
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.substring(1))
    .join(" ");
}

function compareObjects(obj1: Record<any, any>, obj2: Record<any, any>, path: undefined | any = []) {
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // description: takes an input of two objects and returns an array of all the differences between the two //
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////
  let mismatchedKeys = [] as any[];
  if (typeof obj1 !== typeof obj2) {
    if (obj1 !== obj2) {
      mismatchedKeys.push(path);
    }
    return mismatchedKeys;
  }

  if (typeof obj1 !== "object" || obj1 === null) {
    if (obj1 !== obj2) {
      mismatchedKeys.push(path);
    }
    return mismatchedKeys;
  }

  for (const key of Object.keys(obj1)) {
    let newPath = [...path, key] as any[];
    // eslint-disable-next-line no-prototype-builtins
    if (!obj2.hasOwnProperty(key)) {
      mismatchedKeys.push(newPath);
    } else {
      mismatchedKeys = [...mismatchedKeys, ...compareObjects(obj1[key], obj2[key], newPath)];
    }
  }
  return mismatchedKeys;
}


// export the following functions
export default Object.assign(
  {},
  {
		capitalize,
    compareObjects,
  },
);
